
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/editorSearch/views/SearchResultsList/SearchResultsList.scss.css.virtualfile';
        module.exports = {"container":"_container_whnqz_1"};